import React from 'react'
import {Switch, Route} from 'react-router-dom'
import ReservationConfiguration from '../ReservationConfiguration'

const Routes = () => {
  return (
    <Switch>
      <Route path="/reservations/configuration/:group_id" component={ReservationConfiguration} />
    </Switch>
  )
}

export default Routes
